// theme constant
export const gridSpacing = 3;
export const drawerWidth = 217;
export const appDrawerWidth = 320;

const LAYOUT_CONST = {
    VERTICAL_LAYOUT: 'vertical',
    HORIZONTAL_LAYOUT: 'horizontal',
    DEFAULT_DRAWER: 'default',
    MINI_DRAWER: 'mini-drawer'
};
export const FIVE_MEGA_BYTE = 5 * 1024 * 1024;
export const AdminRoleTeamMember = {
    ADMIN: 'admin',
    VIEWER: 'viewer',
    MEMBER: 'member',
    CUSTOM: 'custom'
};
export const AdminAccessLevel = {
    FULL: 'full',
    VIEW: 'view',
    NONE: 'none'
};
export default LAYOUT_CONST;
